import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppliedFilter, FilterType } from '@shared/components/filters/Domain/filter.model';
import { SharedModule } from '@shared/shared.module';
import { SliderModule } from 'primeng/slider';
import { RangeFilterComponent } from '@shared/components/filters/Components/ComplexComponents/range-filter/range-filter.component';
import { ChipsFilterComponent } from '@shared/components/filters/Components/ComplexComponents/chips-filter/chips-filter.component';
import { FilterService } from '@shared/components/filters/Application/Services/filter.service';
import { MultipleFiltersComponent } from '@shared/components/filters/Components/ComplexComponents/multiple-filters/multiple-filters.component';
import { DateRangeFilterComponent } from '@shared/components/filters/Components/ComplexComponents/date-range-filter/date-range-filter.component';

@Component({
  selector: 'app-filter-item',
  standalone: true,
  imports: [
    SharedModule,
    SliderModule,
    RangeFilterComponent,
    ChipsFilterComponent,
    MultipleFiltersComponent,
    DateRangeFilterComponent,
  ],
  templateUrl: './filter-item.component.html',
  styleUrl: './filter-item.component.scss',
})
export class FilterItemComponent implements OnInit {
  @Input() selectedFilter: Record<string, AppliedFilter> = {};
  @Input() selectedFilterId: string = '';
  @Output() valueChange = new EventEmitter<{ filter: AppliedFilter }>();

  protected readonly FilterType = FilterType;

  constructor(private filterService: FilterService) {}

  ngOnInit() {
    const actualFilters = this.filterService.activeFiltersValue;
    actualFilters.forEach((filter) => {
      this.selectedFilter[filter.filter.id] = filter;
      this.valueChange.emit({ filter: filter });
    });
  }

  emitFilterUpdate(filterId: string, value: any) {
    const appliedFilter = this.filterService.applyFilter(filterId, value, this.selectedFilter);
    if (appliedFilter) {
      this.valueChange.emit({ filter: appliedFilter });
    }
  }

  onValueChange(filterId: string, value: any): void {
    this.emitFilterUpdate(filterId, value);
  }

  emitComplexToParent(updatedFilter: AppliedFilter) {
    this.valueChange.emit({ filter: updatedFilter });
  }

  emitSimpleFilter(filterId: string, value: any) {
    const filter = this.selectedFilter[filterId];

    const appliedFilter: AppliedFilter = {
      ...filter,
      isApplied: value.length > 0,
      value: value,
    };

    this.valueChange.emit({ filter: appliedFilter });
  }

  get options() {
    const filter = this.selectedFilter[this.selectedFilterId]?.filter;
    return filter ? (this.filterService.isFilterWithOptions(filter) ? filter.options : []) : [];
  }
}
